{
	"header": {
		"tag": "Myyjäprofiili"
	},
	"soldCount": {
		"none": "Ei myyty kiekkoja vielä",
		"one": "1 kiekko myyty",
		"other": "{{count}} kiekkoa myyty"
	},
	"reviewCount_one": "arvostelu",
	"reviewCount_other": "arvostelua",
	"listings": {
		"empty": "Tällä myyjällä ei ole aktiivisia ilmoituksia juuri nyt.",
		"count_one": "1 aktiivinen ilmoitus",
		"count_other": "{{count}} aktiivista ilmoitusta"
	},
	"reviews": {
		"title": "Arvostelut",
		"empty": "Ei arvosteluja vielä.",
		"howWasExperience": "Miten kokemus sujui?",
		"leaveReviewFor": "Jätä arvostelu käyttäjälle",
		"yourReview": "Arvostelusi",
		"youReviewed": "Arvostelit käyttäjän",
		"forThisPurchase": "tähän ostokseen",
		"resolved": "Ratkaistu"
	},
	"notFound": {
		"code": "404",
		"title": "Myyjää ei löydy",
		"description": "Käyttäjätunnuksella ei löydy myyjää",
		"exists": "olemassa."
	},
	"sold": {
		"stamp": "Myyty",
		"description": "Tämä kiekko on myyty",
		"browse": "Selaa ilmoituksia"
	}
}
